import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { Button } from '../ui/Button';
export function BHRTHero() {
  return <section className="relative pt-[120px] pb-[60px] lg:pt-[160px] lg:pb-[100px] overflow-hidden min-h-[500px] lg:min-h-[70vh] flex items-center" data-id="element-319">
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/bacujminvFbvTotZe6zrdL/Hormone-Replacement.jpg)'
    }} data-id="element-320" />
      <div className="absolute inset-0 bg-black/50" data-id="element-321" />

      <div className="max-w-[1200px] mx-auto px-6 lg:px-8 w-full relative z-10" data-id="element-322">
        <AnimateOnScroll className="w-full lg:w-[55%]" data-id="element-323">
          <div className="mb-6" data-id="element-324">
            <span className="text-[#999999] text-[13px] font-body" data-id="element-325">
              <a href="/treatments" className="hover:text-[#FF1493] transition-colors" data-id="element-326">
                Treatments
              </a>{' '}
              / Medical
            </span>
          </div>

          <span className="text-[#FF1493] uppercase text-sm font-bold tracking-[3px] mb-4 block font-[Poppins,_sans-serif]" data-id="element-327">
            Be CONFIDENT
          </span>

          <h1 className="text-[28px] sm:text-3xl lg:text-[44px] uppercase text-white tracking-tight mb-6 font-[600] font-[Poppins,_sans-serif] leading-none" data-id="element-328">
            BIOIDENTICAL HORMONE REPLACEMENT THERAPY
          </h1>

          <div className="space-y-6" data-id="element-329">
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-330">
              Ladies, let's talk about a true game-changer for women journeying
              from perimenopause to postmenopause: Bioidentical Hormone
              Replacement Therapy (BHRT). As Dr. Fiona points out, if your
              energy levels have hit rock bottom, the scale keeps creeping up
              even though your habits haven't changed, or your workouts no
              longer deliver that lean, toned look, BHRT might just be your new
              best friend.
            </p>
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-331">
              Think about it—your hormones have been knocked off balance, which
              can leave you feeling unlike yourself and even sap your sex drive.
              But imagine waking up feeling vibrant, managing your weight with
              ease, enjoying stronger muscle tone, and reigniting that spark in
              your bedroom. With BHRT, which matches the hormones your body
              naturally produces, this could be your reality.
            </p>
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-332">
              At Be CLINICAL, BHRT is about more than symptom relief—it's about
              helping you reclaim your life. If you're ready to stop feeling
              like a stranger in your own skin and want to embrace the
              confidence and energy you deserve, let's talk. We're here to find
              out if BHRT is the right fit for you.
            </p>
          </div>

          <Button variant="primary" size="lg" className="mt-8 w-full sm:w-auto" data-id="element-333">
            SCHEDULE CONSULTATION
          </Button>
        </AnimateOnScroll>
      </div>
    </section>;
}